<template>
    <div class="fixed z-index-fixed top-0 left-0 w-screen">
        <div class="wrapper-topbar bg-white">
            <div class="side flex">
                <div class="flex" v-if="isLogin" @click="gotoProfile()">
                    <div class="w-28 m-auto text-center text-white text-18">
                        <div class="bg-blue-1 rounded-r-5 h-11 flex">
                            <div class="m-auto">{{ getLevelText() }}</div>
                        </div>
                        <div class="flex justify-center">
                            <div class="text-green-1 mr-1 text-20 font-bold">{{FilterNumberFormat(profile.updated_points.points)}}</div>
                            <div class="text-16 text-blue-1 my-auto">คะแนน</div>
                        </div>
                    </div>
                </div>
                <div class="bg-blue-1 flex" v-else>
                    <div class="m-auto px-2 text-center text-white text-18" @click="gotoLogin()">
                        <div class="font-light">กรุณา</div>
                        <div>เข้าสู่ระบบ</div>
                    </div>
                </div>
            </div>
            <div class="center flex">
                <img class="h-8 m-auto" src="@/assets/icon/ic-splus.svg" alt="" />
            </div>
            <div class="side flex">
                <div class="mr-4 ml-auto my-auto" @click="clickSearch()">
                    <img class="h-5" src="@/assets/icon/ic-top-search.svg" alt="" />
                </div>
                <div class="mr-4 ml-0 relative h-full w-5 flex" @click="clickNoti()" v-if="isLogin">
                    <img class="h-5 m-auto" src="@/assets/icon/ic-top-noti.svg" alt="" />
                    <div v-if="noti != 0"
                        class="absolute top-3 -right-2 w-5 h-5 text-14 bg-red-1 rounded-full flex">
                        <div class="text-center text-white m-auto">{{noti}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ConfigManager from "@/config/ConfigManager";
import { StaticLevel,UserLevel } from "@/core/UserLevel/UserLevelDetail.js";
//mixin
import AuthStatusMixin from "@/mixin/AuthStatusMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
// import BzbsNotification from "@/core/noti/BzbsNotification.js";

export default {
    name: "TopBar",
    mixins: [AuthStatusMixin,LocaleMixin],
    inject: ['SideMenuStore'],
    data: function() {
        return {
            pageActive: this.$route.name,

            showLangSwitch: false,
            level: null,
            //Noti: 0,
            levelName: '',
        };
    },
    created: async function() {
        console.log('profile', this.profile);
        // await this.getListNoti();
   
    },
    methods: {
        // onAccountInit: function() {
        //     //console.log("onAccountInit",this.noti)
        //     // if (this.isLogin) {
        //     //     this.getListNoti();
        //     // }
        // },
        gotoProfile: function () {
            this.$router.push('/profile')
        },
        gotoLogin: function () {
            let url = ConfigManager.getWebSofinUrl();
            window.location.replace(url);
        },
        getLevelText: function () {
            if (this.isLogin) {
                this.level = {...StaticLevel};
                this.userLevel = new UserLevel();
                // console.log(this.level)
                // console.log(this.userLevel.getLevelName(this.level))
                return this.levelName = this.userLevel.getLevelName(this.level);
            } else {
                return "";
            }
        },
        openSideMenu: function() {
            this.SideMenuStore.methods.open();
        },

        //#region lang btn
        toggleLangSwitch: function() {
            if (this.showLangSwitch) {
                this.closeLangMenu();
            } else {
                this.openLangMenu();
            }
        },
        openLangMenu: function() {
            this.showLangSwitch = true;
            document.addEventListener('click', this.documentClick);
        },
        closeLangMenu: function() {
            this.showLangSwitch = false;
            document.removeEventListener('click', this.documentClick);
        },
        documentClick: function(e) {
            let el = this.$refs['lang-menu'];
			let target = e.target;

			if (el !== target && !el.contains(target)) {
				this.closeLangMenu();
			}
        },
        clickSearch: function() {
            if(this.pageActive == 'home') {
                this.tracking.event('home_header', 'click_search');
            } else if (this.pageActive == 'reward') {
                this.tracking.event('reward_header', 'click_search');
            } else if (this.pageActive == 'history') {
                this.tracking.event('point_history_header', 'click_search');
            } else if (this.pageActive == 'activity') {
                this.tracking.event('activity_header', 'click_search');
            }

            this.$router.push('/search')
        },

        clickSwitchLang: function(locale) {
            this.showLangSwitch = false;

            this.switchLang(locale);
        },
        clickNoti: function () {
            if(this.pageActive == 'home') {
                this.tracking.event('home_header', 'click_notification');
            } else if (this.pageActive == 'reward') {
                this.tracking.event('reward_header', 'click_notification');
            } else if (this.pageActive == 'history') {
                this.tracking.event('point_history_header', 'click_notification');
            } else if (this.pageActive == 'activity') {
                this.tracking.event('activity_header', 'click_notification');
            }

            this.$router.push('notification');
        },
        // getListNoti: function () {
        //     return new Promise((resolve) => {
        //         BzbsNotification.apiGetNotiBadge().subscribe({
        //             next: (data) => {
        //                 this.Noti = data.filter(x => x.IsRead == false).length;
        //                 resolve(true)
        //             },
        //             error: (err) => {
        //                 console.log(err);
        //                 resolve(false);
        //             }
        //         });
        //     });
        // },
        //#endregion lang btn
    },
}
</script>
<style lang="scss" scoped>
    .wrapper-topbar {
        display: flex;
        width: 100%;
        height: 70px;
        .side {
            width: calc((100% - 80px) / 2);
        }
        .center {
            width: 80px;
        }
    }

    .ellipsis-1 {
        width: 100%;
        display: -webkit-box;
        -webkit-line-clamp: 1; /* number of lines to show */
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        overflow: hidden;
    }

</style>
